import "core-js/modules/es6.function.name";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
export var SyncMapper =
/*#__PURE__*/
function () {
  function SyncMapper() {
    _classCallCheck(this, SyncMapper);
  }

  _createClass(SyncMapper, [{
    key: "mapContentItemDelta",
    value: function mapContentItemDelta(itemDeltaContract) {
      var _a;

      var systemContract = itemDeltaContract.data.system;
      var elements = itemDeltaContract.data.elements ? itemDeltaContract.data.elements : {};
      return {
        changeType: itemDeltaContract.change_type,
        timestamp: itemDeltaContract.timestamp,
        data: {
          elements: elements,
          system: {
            codename: systemContract.codename,
            collection: systemContract.collection,
            id: systemContract.id,
            language: systemContract.language,
            lastModified: systemContract.last_modified,
            name: systemContract.name,
            sitemapLocations: systemContract.sitemap_locations,
            type: systemContract.type,
            workflowStep: (_a = systemContract.workflow_step) !== null && _a !== void 0 ? _a : null
          }
        }
      };
    }
  }]);

  return SyncMapper;
}();